/**
 * Calls handler and log warning to server after timeout, if it wasn't stop.
 * Throws error if handler or timeout are absent.
 * @param {function} handler - will be called after timeout
 * @param {number} timeout - time in millisecond after which handler will called
 * @param {string} handlerName - name of handler which will be called after timeout,
 * needed for log
 * @constructor
 */
com.inq.net.WatchDog = function (handler, timeout, handlerName) {
	if (handler && timeout) {
		this.timeoutId = null;
		this.timeoutMS = timeout;
		this.handler = handler;
		this.handlerName = handlerName;
		this.restartCalledAt = null;
		this.visibilityChangeListener = this.visibilityChangeListenerCb.bind(this);
	} else {
		throw Error("handler and timeout are required parameters for using WatchDog.");
	}
};

/**
 * Stops previous timeout, starts new one and adds visibility change listener.
 */
com.inq.net.WatchDog.prototype.restart = function () {
	this.stop();
	this.timeoutId = setTimeout(this.handleTimeout.bind(this), this.timeoutMS);
	this.restartCalledAt = Date.now();
	this.addVisibilityChangeListener();
};

com.inq.net.WatchDog.prototype.addVisibilityChangeListener = function () {
	document.addEventListener("visibilitychange", this.visibilityChangeListener);
};

com.inq.net.WatchDog.prototype.removeVisibilityChangeListener = function () {
	document.removeEventListener("visibilitychange", this.visibilityChangeListener);
};

/**
 * This is to fix IJSF-501, when the app is in background for longer than 60s
 * our existing timeout lapses, and there is no polling to get msgs.
 * So this fix would restart the polling for msgs.
 */
com.inq.net.WatchDog.prototype.visibilityChangeListenerCb = function () {
	if (document.visibilityState === "visible" && this.restartCalledAt) {
		var timeDiff = Date.now() - this.restartCalledAt;

		if (timeDiff > 60000) {
			this.stop();
			this.handleTimeout();
		}
	}
};

/**
 * Stops previous timeout and removes visibility change listener.
 */
com.inq.net.WatchDog.prototype.stop = function () {
	clearTimeout(this.timeoutId);
	this.removeVisibilityChangeListener();
};

/**
 * Sends log to server and call handler for timeout.
 */
com.inq.net.WatchDog.prototype.handleTimeout = function () {
	com.inq.flash.client.control.FlashPeer.logWarningToServer(
		"WatchDog timeout worked. " + this.handlerName + " called."
	);
	com.inq.flash.client.control.FlashPeer.sendNetworkBackup();
	this.handler();
};
